import script from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true"

import "./ForgotPassword.vue?vue&type=style&index=0&id=62693480&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62693480"]])

export default __exports__